import React from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';
import { makeStyles, TextField } from '@material-ui/core';
import { RegisterRfqInput } from '@generated/graphql';
import { RootState } from '@modules/index';
import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import { NumberFormatCustom } from '@components/CurrencyTextfield/CurrncyTextField';
import FormInputLayout from '../Layout/FormInputLayout';
import { RequestInputCommonProps } from './types';

const CircuitAssemblyQuantityInput: React.FC<RequestInputCommonProps> = ({
  error
}) => {
  const defaultValue = useSelector<RootState, number | null>(
    (state) => state.request?.pcb?.assemblyQuantity ?? null
  );
  const { control } = useFormContext<RegisterRfqInput>();
  const { assembleQuantityInput } = useStyles();

  return (
    <FormInputLayout label="조립수량" required={true}>
      <Controller
        data-cy="rfq-pcb-assemblyQuantity"
        name="pcb.assemblyQuantity"
        control={control}
        rules={{
          required: '조립수량을 입력해주세요'
        }}
        defaultValue={defaultValue}
        render={({ onChange }) => (
          <TextField
            autoComplete="off"
            className={assembleQuantityInput}
            defaultValue={defaultValue ? defaultValue : ''}
            error={!!error}
            variant="outlined"
            helperText={error}
            fullWidth
            placeholder="0"
            InputProps={{
              inputComponent: NumberFormatCustom,
              onChange: (e) => {
                const value = (e.target as HTMLInputElement).value;
                onChange(+value);
              },
              endAdornment: (
                <CustomizedTypography variant="body1" color="textSecondary">
                  개
                </CustomizedTypography>
              )
            }}
          />
        )}
      />
    </FormInputLayout>
  );
};

export default CircuitAssemblyQuantityInput;

const useStyles = makeStyles((theme) => ({
  assembleQuantityInput: {
    '& input': {
      padding: 12,
      textAlign: 'right'
    },
    '& .MuiInputBase-root': {
      alignItems: 'center',
      borderRadius: 8
    },
    '& ::placeholder': {
      color: colorSet.gray500
    }
  }
}));
